import api from './client'

export const asistenteApi = {
  // El historial lo guarda el servidor: se manda solo el mensaje nuevo y la
  // conversación (null = arranca una nueva).
  chat: (conversacionId, mensaje) => api.post('/asistente/chat', { conversacion_id: conversacionId, mensaje }),
  // Botones ✅/✕ de una acción pendiente (el código lo devuelve el chat).
  confirmar: (conversacionId, codigo) => api.post('/asistente/confirmar', { conversacion_id: conversacionId, codigo }),
  cancelar: (conversacionId, codigo) => api.post('/asistente/cancelar', { conversacion_id: conversacionId, codigo }),
  // SISTEMA → Conversaciones del bot (administradores + personas habilitadas)
  conversaciones: (params) => api.get('/asistente/conversaciones', { params }),
  conversacion: (id) => api.get(`/asistente/conversaciones/${id}`),
  // Sube una captura para adjuntar a una sugerencia/bug (sug #54).
  adjunto: (file) => {
    const fd = new FormData()
    fd.append('imagen', file)
    return api.post('/asistente/adjunto', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
}
